import { PlusCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedDeliverableCreatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface DeliverableCreatedEventProps {
  event: DiscriminatedDeliverableCreatedEvent;
}

export const DeliverableCreatedEvent: React.FC<
  DeliverableCreatedEventProps
> = ({ event }) => {
  const { deliverable } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-emerald-100">
          <PlusCircleIcon className="h-4 w-4 text-emerald-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      {deliverable?.name && <ActivityTitle>{deliverable.name}</ActivityTitle>}
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Deliverable Created"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
